<script lang="ts">
  import Toast from './Toast.svelte';
  import { toasts, type ToastQueue } from './toast-queue.svelte';

  interface Props {
    queue?: ToastQueue;
  }

  let { queue = toasts }: Props = $props();
  const current = $derived(queue.current);
</script>

<div class="region">
  {#if current}
    {#key current.id}
      <Toast
        message={current.message}
        kind={current.kind}
        durationMs={current.durationMs}
        {...current.action ? { action: current.action } : {}}
        onclose={() => queue.dismiss(current.id)}
      />
    {/key}
  {/if}
</div>

<style>
  .region {
    position: fixed;
    left: 50%;
    bottom: max(var(--space-5), env(safe-area-inset-bottom));
    transform: translateX(-50%);
    z-index: var(--z-toast);
    display: flex;
    justify-content: center;
    pointer-events: none;
  }
  .region > :global(*) {
    pointer-events: auto;
  }
</style>
